import Ajax from "DMS/Seed/Seed.Ajax";
let googleMapsLoaded = null;
let urlPrefix = "";
async function injectScript(src) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.addEventListener('load', resolve);
        script.addEventListener('error', e => reject(e.error));
        document.head.appendChild(script);
    });
}
async function getGoogleMapsKeyWeb() {
    return Ajax.Post({
        url: urlPrefix + "RequestBuilder/getGoogleMapsKeyWeb.php",
        async: true
    });
}
// Promise that is resolved when the google map API is loaded
export async function googleAPILoader() {
    let googleMapsKeyWeb = await getGoogleMapsKeyWeb();
    // @todo : Gérer le callback ?
    let url = 'https://maps.googleapis.com/maps/api/js?key=' + googleMapsKeyWeb;
    return injectScript(url);
}
export default function (baseUrl) {
    if (!googleMapsLoaded) {
        urlPrefix = baseUrl;
        googleMapsLoaded = googleAPILoader();
    }
    return googleMapsLoaded;
}
;
//# sourceMappingURL=GoogleMapLoader.js.map